var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('CourseDetail',{attrs:{"packageId":_vm.packageId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }